import { useRef } from 'react';

import { getPlaceholderHtml as getNumberPlaceholderHtml } from '@components/field-mapping-number-field/extensions';
import { Form } from '@components/form';
import { IconAddPlus } from '@components/icons/add-plus';
import { PopoverButton } from '@components/popover-button';
import { useScopedTranslate } from '@locale/translate';
import { pxToRem } from '@utils/converters';
import { formatNumber } from '@utils/numbers';
import { uuid } from '@utils/uuid';

import { EditorRefProp } from '../common';
import { locale } from '../field-mapping-sidebar';

export const NumberManualField = ({
  editorRef,
  isDecimal,
}: EditorRefProp & { isDecimal?: boolean }) => {
  const { t } = useScopedTranslate(locale);
  const fieldId = useRef(uuid()).current;
  return (
    <PopoverButton
      placement="bottom-start"
      triggerProps={{
        iconLeft: <IconAddPlus />,
        variant: 'secondary',
        text: t('addNumber'),
      }}
      contentStyle={{ maxWidth: pxToRem(392) }}
    >
      {({ close }) => (
        <Form
          onSubmit={(values) => {
            const value = values[fieldId];
            const number = typeof value === 'number' ? value : Number(value);
            if (Number.isFinite(number)) {
              const label = formatNumber(number);
              editorRef.current?.insertContent(getNumberPlaceholderHtml({ value, label }));
              close();
            }
          }}
        >
          <Form.NumberField id={fieldId} label={t('numberLabel')} isDecimal={isDecimal} />
          <Form.Actions>
            <Form.Reset text={t('core.cancel')} onClick={() => close()} />
            <Form.Submit variant="primary-blue" text={t('core.add')} iconLeft={<IconAddPlus />} />
          </Form.Actions>
        </Form>
      )}
    </PopoverButton>
  );
};
